<template>
  <a-table
    :dataSource="dataSource"
    :columns="columns"
    class="mb40"
    :pagination="pagination"
  >
    <template v-slot:bodyCell="{ column, record }">
      <template v-if="column.dataIndex == 'taskType'">
        {{ record.taskType === 1 ? '浏览任务' : '浏览任务' }}
      </template>
      <template v-if="column.dataIndex == 'showType'">
        {{ record.showType === 1 ? 'icon' : 'banner' }}
      </template>
      <!-- <template v-if="column.dataIndex == 'taskId'">
        <span v-for="(item, index) in JSON.parse(record.taskId)" :key="index">
          {{ item }}<br
        /></span>
      </template> -->
      <template v-if="column.dataIndex == 'operate'">
        <a-button type="link" @click="handleEdit(1, record)">
          编辑
        </a-button>
        <a-popconfirm title="确定删除吗?" @confirm="handleDel(record)">
          <a-button type="link">
            删除
          </a-button>
        </a-popconfirm>
      </template>
    </template>
  </a-table>
</template>

<script>
import { inject, toRefs } from 'vue'
export default {
  setup() {
    return {
      ...toRefs(inject('initState'))
    }
  }
}
</script>

<style lang="scss" scoped></style>
